import chatbox from './chatbox';
export default chatbox;


// WEBPACK FOOTER //
// /src/call/container/chatbox/index.js